import { render, staticRenderFns } from "./HubSystem.vue?vue&type=template&id=c0b95108&scoped=true&"
import script from "./HubSystem.vue?vue&type=script&lang=js&"
export * from "./HubSystem.vue?vue&type=script&lang=js&"
import style0 from "./HubSystem.vue?vue&type=style&index=0&id=c0b95108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b95108",
  null
  
)

export default component.exports